import type { FunctionalComponent } from 'vue'
import './index.scss'

type Props = {
  dir?: string
  name: string
  className?: string
  style?: string
  size?: number
  onClick?: () => void
}
export const SvgIcon: FunctionalComponent<Props> = (props) => {
  const { dir = '', name, className = '', onClick = () => {}, style = '', size = 0 } = props
  const href = `#icon-${dir ? dir + '-' : ''}${name}`
  return (
    <div class="svg-icon-layout" style={size > 0 ? { '--svg-icon-size': `${size}px` } : undefined}>
      <div class={'svg-icon-container flex items-center justify-center'} style={style} onClick={onClick}>
        <svg class={className} aria-hidden="true">
          <use href={href} />
        </svg>
      </div>
    </div>
  )
}
